import {useDebugValue} from 'react';

import {useSettings} from './';

const defaultSettings = {
    isTypeaheadInputFocus: false
};

function useDestinationSettings(props) {
    const {
        destinationSettings: propsSettings
    } = props;

    const {
        initialSettings,
        settings,
        changeSettings
    } = useSettings(defaultSettings, propsSettings);

    const result = {
        initialSettings,
        settings,
        changeSettings
    };

    useDebugValue(result);

    return result;
}

export {useDestinationSettings};
